/**
 * This component renders the sidebar for a game page
 * WARNING - Currently using some dummy data
 */
import React from "react";
import StatsBarSection from "./StatsBarSection";
import ProfileImageContainer from "../core/ProfileImageContainer.js";
import { Link } from "react-router-dom";
import { formatEpochDate } from "../utils/time.js";


const GameDetails = (data) => {
  let game_data = data.game_data;
  let sidebar_data = data.sidebar_data;

  const gradientStyle = {
    background: `linear-gradient(to right, ${game_data.home_team.primary_color}, ${game_data.away_team.primary_color})`,
  };

  return (
    <>
      <div className="flex flex-row justify-between items-center mb-1">
        <img
          src={`${game_data.home_team.logo.lg}`}
          alt={game_data.home_team.name}
          className="h-8 w-8"
        />
        <h1 className="text-xl font-normal">Game Stats</h1>
        <img
          src={`${game_data.away_team.logo.lg}`}
          alt={game_data.away_team.name}
          className="h-8 w-8"
        />
      </div>
      {/* Gradient line */}

      {(sidebar_data.key_goal != null ||
        sidebar_data.home_mvp != null ||
        sidebar_data.away_mvp != null) && (
        <div className="w-full h-2 mt-2" style={gradientStyle}>
          <p className="hidden">Gradient line</p>
        </div>
      )}

      <div className="flex flex-wrap justify-between items-center w-full">
        {sidebar_data.key_goal != null && (
          <div className="xxs:mx-2 mt-4">
            <Link
              to={`/player/${sidebar_data.key_goal.id}`}
              className="flex flex-row justify-start items-center group"
            >
              <div className="h-14 w-14 mr-2 rounded-full bg-white dark:bg-dark-2 flex flex-col justify-center items-center">
                <ProfileImageContainer
                  player={sidebar_data.key_goal.id}
                  club={sidebar_data.key_goal.club}
                  backup={sidebar_data.key_goal.profile}
                  alt={sidebar_data.key_goal.name}
                  extraClasses={"rounded-full"}
                />
              </div>
              <div className="flex flex-col justify-start items-start">
                <p className="max-xs:text-xs xxs:flex hidden text-left whitespace-nowrap group-hover:text-buiha-red dark:group-hover:text-dark-5 ease-in-out duration-200">
                  #{sidebar_data.key_goal.number} {sidebar_data.key_goal.name}
                </p>
                <p className="flex xxs:hidden font-semibold text-left font-light text-darken whitespace-nowrap group-hover:text-buiha-red dark:group-hover:text-dark-5 ease-in-out duration-200">
                  #{sidebar_data.key_goal.number} - {sidebar_data.key_goal.name}
                </p>
                <p className="max-xs:text-xs text-darken font-light">{sidebar_data.key_goal.type}</p>
              </div>
            </Link>
          </div>
        )}

        {sidebar_data.home_mvp != null && (
          <div className="mx-2 mt-2">
            <Link
              to={`/player/${sidebar_data.home_mvp.id}`}
              className="flex flex-row justify-start items-center group"
            >
              <div className="h-14 w-14 mr-2 rounded-full bg-white dark:bg-dark-2 flex flex-col justify-center items-center">
                <ProfileImageContainer
                  player={sidebar_data.home_mvp.id}
                  club={game_data.home_team.club}
                  backup={game_data.home_team.profile}
                  alt={sidebar_data.home_mvp.name}
                  extraClasses={"rounded-full"}
                />
              </div>
              <div className="flex flex-col justify-start items-start">
                <p className="text-left whitespace-nowrap group-hover:text-buiha-red dark:group-hover:text-dark-5 ease-in-out duration-200">
                  #{sidebar_data.home_mvp.number} {sidebar_data.home_mvp.name}
                </p>
                <p className="max-xs:text-xs text-darken font-light">
                  MVP, {game_data.home_team.name}
                </p>
              </div>
            </Link>
          </div>
        )}

        {sidebar_data.away_mvp != null && (
          <div className="mx-2 mt-2">
          <Link
            to={`/player/${sidebar_data.away_mvp.id}`}
            className="flex flex-row justify-start items-center group"
          >
            <div className="h-14 w-14 mr-2 rounded-full bg-white dark:bg-dark-2 flex flex-col justify-center items-center">
              <ProfileImageContainer
                player={sidebar_data.away_mvp.id}
                club={game_data.away_team.club}
                backup={game_data.away_team.profile}
                alt={sidebar_data.away_mvp.name}
                extraClasses={"rounded-full"}
              />
            </div>
            <div className="flex flex-col justify-start items-start">
              <p className="text-left whitespace-nowrap group-hover:text-buiha-red dark:group-hover:text-dark-5 ease-in-out duration-200">
                #{sidebar_data.away_mvp.number} {sidebar_data.away_mvp.name}
              </p>
              <p className="max-xs:text-xs text-darken font-light">MVP, {game_data.away_team.name}</p>
            </div>
          </Link>
          </div>
        )}
      </div>

      {/* Gradient line */}
      <>
        <div className="w-full h-2 mt-4" style={gradientStyle}>
          <p className="hidden">Gradient line</p>
        </div>

        <div className="flex flex-col justify-start xl:items-start items-center w-full my-4">
          <div className="flex flex-row justify-between items-center w-full">
            <p className="text-left lg:b-2 max-xs:text-xs pr-2 font-normal pb-0.5">
              Date:
            </p>
            <p className="text-right lg:b-2 max-xs:text-xs font-light">
              {formatEpochDate(game_data.date)}
            </p>
          </div>
          <div className="flex flex-row justify-between items-center w-full">
            <p className="text-left lg:b-2 max-xs:text-xs pr-2 font-normal pb-0.5">
              Face Off:
            </p>
            <p className="text-right lg:b-2 max-xs:text-xs font-light">{game_data.time_text}</p>
          </div>
          <div className="flex flex-row justify-between items-center w-full">
            <p className="text-left lg:b-2 max-xs:text-xs pr-2 font-normal pb-0.5">
              Location:
            </p>
            <p className="text-right lg:b-2 max-xs:text-xs font-light">{game_data.location}</p>
          </div>
          <div className="flex flex-row justify-between items-center w-full">
            <p className="text-left lg:b-2 max-xs:text-xs pr-2 font-normal pb-0.5">
              Competition:
            </p>
            <p className="text-right lg:b-2 max-xs:text-xs font-light">{game_data.division.name}</p>
          </div>
          <div className="flex flex-row justify-between items-center w-full">
            <p className="text-left lg:b-2 max-xs:text-xs pr-2 font-normal pb-0.5">
              Season:
            </p>
            <p className="text-right lg:b-2 max-xs:text-xs font-light">
              20{game_data.division.season}
            </p>
          </div>
          {/* TODO ADD THIS FUNCTIONALITY
          <div className="flex flex-row justify-between items-center w-full">
            <p className="text-left lg:b-2 max-xs:text-xs pr-2 font-normal pb-0.5">
              Format:
            </p>
            <p className="text-right lg:b-2 max-xs:text-xs font-light">3x 20min Regulation</p>
          </div>
          */}
        </div>

        <div className="w-full h-2 mt-4" style={gradientStyle}>
          <p className="hidden">Gradient line</p>
        </div>

        <div className="rounded w-full my-4">
          <table className="table-auto w-full">
            <thead>
              <tr>
                <th className="text-left pb-1 lg:b-2 max-xs:text-xs font-normal">Goals</th>
                {Object.keys(sidebar_data.boxscore).map((period) => (
                  <th className="text-center pb-1 lg:b-2 max-xs:text-xs font-normal">{period}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-left max-lg:w-1/3">
                  <div className="flex flex-row items-center justify-start">
                    <img
                      src={`${game_data.home_team.logo.lg}`}
                      alt={game_data.home_team.name}
                      className="mr-2 inline object-cover w-6 h-6"
                    />
                    <p className="">{game_data.home_team.blip}</p>
                  </div>
                </td>
                {Object.keys(sidebar_data.boxscore).map((period) => (
                  <td className="text-center font-light">
                    {sidebar_data.boxscore[period]["home_goals"]}
                    <small className=" font-light pl-1">
                      ({sidebar_data.boxscore[period]["home_shots"]})
                    </small>
                  </td>
                ))}
              </tr>
            </tbody>

            <tbody>
              <tr>
                <td className="text-left max-lg:w-1/3">
                  <div className="flex flex-row items-center justify-start">
                    <img
                      src={`${game_data.away_team.logo.lg}`}
                      alt={game_data.away_team.name}
                      className="mr-2 inline object-cover w-6 h-6"
                    />
                    <p className="">{game_data.away_team.blip}</p>
                  </div>
                </td>
                {Object.keys(sidebar_data.boxscore).map((period) => (
                  <td className="text-center font-light">
                    {sidebar_data.boxscore[period]["away_goals"]}
                    <small className="text-light pl-1">
                      ({sidebar_data.boxscore[period]["away_shots"]})
                    </small>
                  </td>
                ))}
              </tr>
            </tbody>
            <thead>
              <tr>
                <th className="text-left pb-1 pt-4 lg:b-2 max-xs:text-xs font-normal">Penalties</th>
                {Object.keys(sidebar_data.boxscore).map((period) => (
                  <th className="text-center pb-1 pt-4 lg:b-2 max-xs:text-xs font-normal">{period}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-left max-lg:w-1/3">
                  <div className="flex flex-row items-center justify-start">
                    <img
                      src={`${game_data.home_team.logo.lg}`}
                      alt={game_data.home_team.name}
                      className="mr-2 inline object-cover w-6 h-6"
                    />
                    <p className="">{game_data.home_team.blip}</p>
                  </div>
                </td>
                {Object.keys(sidebar_data.boxscore).map((period) => (
                  <td className="text-center font-light">
                    {sidebar_data.boxscore[period]["home_penalties"]}
                  </td>
                ))}
              </tr>
            </tbody>

            <tbody>
              <tr>
                <td className="text-left max-lg:w-1/3">
                  <div className="flex flex-row items-center justify-start">
                    <img
                      src={`${game_data.away_team.logo.lg}`}
                      alt={game_data.away_team.name}
                      className="mr-2 inline object-cover w-6 h-6"
                    />
                    <p className="">{game_data.away_team.blip}</p>
                  </div>
                </td>
                {Object.keys(sidebar_data.boxscore).map((period) => (
                  <td className="text-center">
                    {sidebar_data.boxscore[period]["away_penalties"]}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>

        <div className="w-full h-2 mt-4" style={gradientStyle}>
          <p className="hidden">Gradient line</p>
        </div>

        <>
          <div className="flex flex-row justify-between items-center mt-4 mb-2">
            <img
              src={`${game_data.home_team.logo.lg}`}
              alt={game_data.home_team.name}
              className="h-8 w-8"
            />
            <h1 className="text-xl font-normal">Team Stats</h1>
            <img
              src={`${game_data.away_team.logo.lg}`}
              alt={game_data.away_team.name}
              className="h-8 w-8"
            />
          </div>

          <div className="mx-auto flex flex-row justify-center items-center w-full">
            <div className="xl:w-full w-full max-w-[800px]">
              <StatsBarSection
                statName="Shots On Goal"
                stat1={sidebar_data.boxscore["T"]["home_shots"]}
                stat2={sidebar_data.boxscore["T"]["away_shots"]}
                pct1={sidebar_data.home_sog_pct}
                pct2={sidebar_data.away_sog_pct}
                col1={game_data.home_team.primary_color}
                col2={game_data.away_team.primary_color}
              />

              <StatsBarSection
                statName="Accuracy"
                stat1={sidebar_data.home_acc.toFixed(2)}
                stat2={sidebar_data.away_acc.toFixed(2)}
                pct1={sidebar_data.home_acc_pct}
                pct2={sidebar_data.away_acc_pct}
                col1={game_data.home_team.primary_color}
                col2={game_data.away_team.primary_color}
              />

              <StatsBarSection
                statName="Penalty Minutes"
                stat1={sidebar_data.boxscore["T"]["home_penalties"]}
                stat2={sidebar_data.boxscore["T"]["away_penalties"]}
                pct1={sidebar_data.home_pim_pct}
                pct2={sidebar_data.away_pim_pct}
                col1={game_data.home_team.primary_color}
                col2={game_data.away_team.primary_color}
              />

              <StatsBarSection
                statName="Power Play %"
                stat1={sidebar_data.home_ppe}
                stat2={sidebar_data.away_ppe}
                pct1={sidebar_data.home_ppe_pct}
                pct2={sidebar_data.away_ppe_pct}
                col1={game_data.home_team.primary_color}
                col2={game_data.away_team.primary_color}
              />

              <StatsBarSection
                statName="Roster Size"
                stat1={sidebar_data.home_bench}
                stat2={sidebar_data.away_bench}
                pct1={sidebar_data.home_bench_pct}
                pct2={sidebar_data.away_bench_pct}
                col1={game_data.home_team.primary_color}
                col2={game_data.away_team.primary_color}
              />
            </div>
          </div>
        </>
      </>
    </>
  );
};

export default GameDetails;
